<template>
    <b-card   header-tag="header" >
        <template #header>
            <div class="w-100 d-flex justify-content-between">
                <b-breadcrumb class="breadcrumb-slash "  style="width: 50%;" v-if="breadcrumbsData.length > 0">
                  <template v-for="(bred,index) in breadcrumbsData" >
                    <b-breadcrumb-item v-if="(index+1) == breadcrumbsData.length"  :key="'b-'+index" active>
                      {{  bred.title }}
                    </b-breadcrumb-item>
                    <b-breadcrumb-item v-else  :key="'b-'+index" >
                        <b-link  @click="clickBread(bred,index)"> {{  bred.title }} </b-link>
                    </b-breadcrumb-item>
                  </template>
                </b-breadcrumb>
                <div>
                    <b-button 
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-success mr-2"
                        @click="newFolder"
                    >
                        New Folder
                    </b-button>
                    <b-button 
                        v-if="parent > 0"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        @click="uploadFiles"
                    >
                        Upload Video
                    </b-button>
                </div>
            </div>
            <hr />
        </template>
        <draggable
            v-model="folders"
            tag="ul"
            class="list-group d-flex flex-wrap   list-group-horizontal cursor-move"
            @change="changeOrderFolder"
        >
            <template
                v-for="(item, index) in folders"
            >
                <b-list-group-item 
                    v-if="!item.types"
                    :key="'folder-'+index"
                    tag="li"
                    class="border-0 text-center p-2"
                    @contextmenu.prevent="$refs.folder.open($event,item)"
                >
                    <div @dblclick="openFolder(item)">
                        <feather-icon
                            icon="FolderIcon"
                            size="62"
                        />
                        <div class="text-center">
                            <strong> {{ item.title }} </strong>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item 
                    v-else
                    :key="'file-'+index"
                    tag="li"
                    class="border-0 text-center p-2"
                    @contextmenu.prevent="$refs.files.open($event,item)"
                >
                    <div>
                        <b-img
                            :src="item.fullpath"
                            v-if="item.types == 'i'"
                            style="height: 62px;"
                            thumbnail
                        />
                        <feather-icon
                            icon="FileIcon"
                            size="62"
                            v-else
                        />
                        <div class="text-center">
                            <strong> {{ item.title }} </strong>
                        </div>
                    </div>
                </b-list-group-item>
            </template>
        </draggable>
        <vue-context ref="folder" @open="onOpen">
            <li>
                <b-link
                    v-for="data in menuFolder"
                    :key="data.text"
                    class="d-flex align-items-center"
                    @click="onOptionClick(data,itemData)"
                >
                    <feather-icon
                        :icon="data.icon"
                        size="16"
                    />
                    <span class="ml-75">{{ data.text }}</span>
                </b-link>
            </li>
        </vue-context>
        <vue-context ref="files"  @open="onOpen"  >
            <li>
                <b-link
                    v-for="data in menuFiles"
                    :key="data.text"
                    class="d-flex align-items-center"
                    @click="optionFileClicked(data,itemData)"
                >
                    <feather-icon
                        :icon="data.icon"
                        size="16"
                    />
                    <span class="ml-75">{{ data.text }}</span>
                </b-link>
            </li>
        </vue-context>
        <rename-modal :is-modal-rename-show.sync="isModalRenameShow" :itemData.sync="itemData" @refetch-data="getAll" />
        <new-folder-modal :is-modal-new-folder-show.sync="isModalNewFolderShow" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" />
        <upload-files-modal :is-modal-upload-files-show.sync="isModalUploadFilesShow" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" />
        <files-detail-modal :is-modal-detail-files-show.sync="isModalDetailFilesShow" :itemData.sync="itemData" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" />
    </b-card>
</template>

<script>
import { ref,onUnmounted } from '@vue/composition-api'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Ripple from 'vue-ripple-directive'
import {
    BCard,BCardHeader, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
    BListGroup,BListGroupItem,BBreadcrumb, BBreadcrumbItem
} from 'bootstrap-vue'
import VueContext from 'vue-context'
import useUploadVideoForm from './useUploadVideoForm'
import RenameModal from '../../uploadStorage/RenameModal.vue'
import NewFolderModal from '../../uploadStorage/NewFolderModal.vue'
import UploadFilesModal from '../../uploadStorage/UploadFilesModal.vue'
import FilesDetailModal from '../../uploadStorage/FilesDetailModal.vue'
import axios from '@axios'
import store from '@/store'
import folderStoreModule from '../../files/folderStoreModule'
import filesStoreModule from '../../files/filesStoreModule'

export default {
    components:{
        BCard,BCardHeader, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
        draggable,Prism,VueContext, BListGroup,BListGroupItem, RenameModal, NewFolderModal,
        UploadFilesModal, BBreadcrumb, BBreadcrumbItem, FilesDetailModal
    },

    directives:{
        'b-modal': VBModal,
        Ripple
    },

    props: {
        uploadType: {
            type: String
        },
        folders: {
            type: Array
        }
    },

    setup(props, {emit}){
        const FOLDER_STORE_MODULE_NAME = 'files-folder'
        if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
        onUnmounted(() => {
            if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
        });

        const FILES_STORE_MODULE_NAME = 'app-files'
        if (!store.hasModule(FILES_STORE_MODULE_NAME)) store.registerModule(FILES_STORE_MODULE_NAME, filesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(FILES_STORE_MODULE_NAME)) store.unregisterModule(FILES_STORE_MODULE_NAME)
        });

        const folderList = ref(props.folders)
        const menuf =  [
            { icon: 'FileIcon', text: 'Open' },
            { icon: 'PlusIcon', text: 'Rename' },
            { icon: 'XIcon', text: 'Delete' },
        ]
        const menuFolder = ref(JSON.parse(JSON.stringify(menuf)));
        const menufi =  [
            { icon: 'FileTextIcon', text: 'Detail' },
            { icon: 'DownloadIcon', text: 'Download' },
            { icon: 'XIcon', text: 'Delete' },
        ]
        const menuFiles = ref(JSON.parse(JSON.stringify(menufi)));
        const isModalRenameShow = ref(false);
        const isModalNewFolderShow = ref(false);
        const itemData = ref({});
        const parent = ref(0);

        const getAll = async() => {
            folderList.value = [];

            let filter = {
                parent:parent.value,
                order_by:'ordering_count ASC'
            }

            const frds = await store.dispatch('files-folder/fetchData', filter);
            console.log('feds', frds)
            if(frds.data.success){
                const filterData = frds.data.data
                folderList.value = filterData.filter((i) => i.types !== 'o')
            }

            emit('refresh');
        }

        const newFolder = ()=>{
            isModalNewFolderShow.value = true;
        }   

        const optionClicked = (data,item)=>{
            if(data.text == 'Rename'){
                isModalRenameShow.value = true;
            }

            if(data.text == 'Detail'){
                isModalDetailFilesShow.value = true;
            }
        
            if(data.text == 'Open'){
                parent.value = item.id;
                breadcrumbsData.value.push(item)
                getAll();
            }
        }

        const changeOrderFolder = async() => {
            const rest =  await store.dispatch('files-folder/updateOrdering',folders.value);
        }
      
        // const {
        //     folders,
        //     fileslist,
        //     changeOrderFolder,
        //     openFolder,
        //     menuFolder,
        //     optionClicked,
        //     isModalRenameShow,
        //     isModalNewFolderShow,
        //     isModalUploadFilesShow,
        //     isModalDetailFilesShow,
        //     getAll,
        //     itemData,
        //     breadcrumbsData,
        //     clickBread,
        //     parent,
        //     newFolder,
        //     deleteData,
        //     deleteFilesData,
        //     uploadFiles,
        //     menuFiles
        // } = useUploadVideoForm();

        return {
            getAll,
            changeOrderFolder,
            menuFolder,
            menuFiles,
            optionClicked,
            isModalRenameShow,
            itemData,
            isModalNewFolderShow,
            parent,
        }
    },

    data() {
    },

    methods:{
        async forceFileDownload(item){ 
            let res = await axios.get(item.fullpath, { responseType: 'blob' });
            var FILE = window.URL.createObjectURL(new Blob([res.data]));
            var docUrl = document.createElement('a');
            docUrl.href = FILE;
            docUrl.setAttribute('download', item.filename);
            document.body.appendChild(docUrl);
            docUrl.click();
        },

        onOpen(event,data) {
          this.itemData = data;
        },

        optionFileClicked(data,item){
            if(data.text == 'Delete'){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete File Name '+item.name, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                        if(value === true){
                            this.deleteFilesData(item.id)
                        }
                    })
            } else if(data.text == 'Download') {
                this.forceFileDownload(item);
            }else{
                this.optionClicked(data,item);
            }
        },

        onOptionClick(data,item){
          if(data.text == 'Delete'){
              this.$bvModal
              .msgBoxConfirm('Please confirm that you want to delete Folder Name '+item.title, {
              title: 'Please Confirm',
              size: 'sm',
              okVariant: 'danger',
              okTitle: 'Yes',
              cancelTitle: 'No',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
              })
              .then(value => {
                  if(value === true){
                    this.deleteData(item.id)
                  }
              
              //this.deleteData(id)
              })

          }else{
            this.optionClicked(data,item);
          }
          
           // this.$refs.menu.open
        }
    }
    
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-context.scss';
.list-group-horizontal {
    flex-direction: row;
    li{
      width: 150px;
    }
}

</style>